import { EventEmitter } from '@angular/core';

export class MyDetailsEvents {
  readonly postcodeSaved = new EventEmitter();
  readonly ageSaved = new EventEmitter();
  readonly namesSaved = new EventEmitter();
  readonly genderSaved = new EventEmitter();
  readonly notificationPreferencesSaved = new EventEmitter();
  readonly preferredEmailSaved = new EventEmitter();
  readonly preferredPhoneNumberSaved = new EventEmitter();
  readonly addressSaved = new EventEmitter();
  readonly subscribedServicesSaved = new EventEmitter();
}



// WEBPACK FOOTER //
// ./app/mydetails/mydetails.events.ts